import { useId } from 'react';
import { useRegisterModal } from '@/contexts/layout/use-register-modal';
import { STRETCH_BACKDROP } from './Cstretchmodal.constants';

const CSTRETCHMODAL_REGISTRATION_ID = 'cstretchmodal';

interface UseCstretchmodalRegistrationInput {
  handleClose: () => void;
  visible: boolean;
}

interface CstretchmodalRegistrationModel {
  modalId: string;
  registration: ReturnType<typeof useRegisterModal>;
}

export function useCstretchmodalRegistration({
  handleClose,
  visible,
}: UseCstretchmodalRegistrationInput): CstretchmodalRegistrationModel {
  const modalRegistrationId = useId();
  const modalId = `${CSTRETCHMODAL_REGISTRATION_ID}-${modalRegistrationId}`;
  const registration = useRegisterModal({
    id: modalId,
    visible,
    onClose: handleClose,
    backdrop: STRETCH_BACKDROP,
    holdUntilExitComplete: true,
  });

  return { modalId, registration };
}
